import React from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import SubHeader from '../header/subheader';
import Delivery from '../dashboard/delivery-card';
import Conversation from '../dashboard/conversation-card';
import OverallCard from '../dashboard/overall-card';
import LitlePaperCard from '../dashboard/litlePaper-card';
import AverageCard from '../dashboard/average-card';
import useThemeQuery from '../../graphql/queries/toggle-theme';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root: {
    // flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  pmText: {
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 0.1,
    marginLeft: -8
  },
  hourText: {
    color: "#000",
    fontSize: 28,
  },
  hourTheme: {
    color: "#ADB9D7",
  }
}));

export default function FullWidthGrid() {
  const classes = useStyles();
  const { data } = useThemeQuery();
  const { formatMessage } = useIntl();
  const hours = (
      <Box>
          <Box component="span" classes={{root: clsx(classes.hourText, data.theme && classes.hourTheme)}} m={1.5}>2:32</Box> 
          <Box component="span" className={classes.pmText}>PM</Box>
      </Box>
  );

  return (
    <div className={classes.root}>
      <SubHeader 
        isMode={true}
        times={hours}
        theme={data && data.theme}
      />
      <Grid container spacing={5}>
        <Grid item xs>
          <OverallCard theme={data && data.theme} />
          <Conversation 
            theme={data && data.theme} 
          />
        </Grid>
        <Grid item xs={4}>
          <Delivery theme={data && data.theme} />
          <AverageCard 
            theme={data && data.theme}
          />
        </Grid>
        <Grid item xs>
        <LitlePaperCard 
            title={formatMessage({id:"app.subHeader.dashboard.refunds", defaultMessage: "Refunds"})} 
            percentage='+7,12'
            theme={data && data.theme}
            />
          <LitlePaperCard 
            title={formatMessage({id:"app.subHeader.dashboard.talktosomeone", defaultMessage: "Talk to someone"})} 
            percentage='+4,1'
            theme={data && data.theme}
            />

          <LitlePaperCard 
            title={formatMessage({id:"app.subHeader.dashboard.certificate", defaultMessage: "Certificate"})} 
            percentage='-5,6'
            theme={data && data.theme}
            />
          <LitlePaperCard 
            title={formatMessage({id:"app.subHeader.dashboard.delivery", defaultMessage: "Delivery"})} 
            percentage='+2,7'
            theme={data && data.theme}
            />
        </Grid>
      </Grid>
    </div>
  );
}